import { render, staticRenderFns } from "./TabContentRules.vue?vue&type=template&id=a1e31408"
import script from "./TabContentRules.vue?vue&type=script&lang=js"
export * from "./TabContentRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports